module.exports = __webpack_public_path__ + "static/media/CRUW3D_cover.e12792a9.jpg";